document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.brand-cards-slider');

    function getLayoutMode() {
        if (window.matchMedia('(max-width: 767px)').matches) {
            return 'mobile';
        }
        if (window.matchMedia('(max-width: 991px)').matches) {
            return 'tablet';
        }
        return 'desktop';
    }

    function normalizeCol(card) {
        const col = parseInt(card.dataset.desktopCol, 10);
        return col === 12 ? 12 : 4;
    }

    function groupDesktop(cards) {
        const pages = [];
        let row = [];
        let sum = 0;

        for (const card of cards) {
            const col = normalizeCol(card);

            if (sum + col > 12 && row.length) {
                pages.push(row);
                row = [];
                sum = 0;
            }

            row.push(card);
            sum += col;

            if (sum >= 12) {
                pages.push(row);
                row = [];
                sum = 0;
            }
        }

        if (row.length) {
            pages.push(row);
        }

        return pages;
    }

    function groupTablet(cards) {
        const pages = [];
        let row = [];

        for (const card of cards) {
            row.push(card);

            if (row.length === 2) {
                pages.push(row);
                row = [];
            }
        }

        if (row.length) {
            pages.push(row);
        }

        return pages;
    }

    function groupMobile(cards) {
        return cards.map((card) => [card]);
    }

    function groupForMode(cards, mode) {
        if (mode === 'mobile') {
            return groupMobile(cards);
        }
        if (mode === 'tablet') {
            return groupTablet(cards);
        }
        return groupDesktop(cards);
    }

    function collectCardsInOrder(wrapper) {
        return Array.from(wrapper.querySelectorAll('.brand-card-slide-col'));
    }

    function getAnchorCardIndex(wrapper, swiper) {
        if (!swiper || swiper.destroyed || typeof swiper.activeIndex !== 'number') {
            return 0;
        }

        const slides = wrapper.querySelectorAll(':scope > .swiper-slide');
        let index = 0;

        for (let i = 0; i < swiper.activeIndex && i < slides.length; i++) {
            index += slides[i].querySelectorAll('.brand-card-slide-col').length;
        }

        return index;
    }

    function slideIndexContainingCard(groups, firstCardIndex) {
        let offset = 0;

        for (let i = 0; i < groups.length; i++) {
            const count = groups[i].length;
            if (firstCardIndex >= offset && firstCardIndex < offset + count) {
                return i;
            }
            offset += count;
        }

        return 0;
    }

    function buildSlidesFromGroups(wrapper, groups) {
        const slides = groups.map((group) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide brand-cards-slider-page';

            const inner = document.createElement('div');
            inner.className = 'brand-cards-slider-page-inner';

            group.forEach((card) => inner.appendChild(card));
            slide.appendChild(inner);

            return slide;
        });

        wrapper.replaceChildren(...slides);
    }

    function equalizeCardHeights(slider) {
        const cards = Array.from(slider.querySelectorAll('.brand-card'));

        if (!cards.length) {
            return;
        }

        cards.forEach((card) => {
            card.style.minHeight = '';
        });

        const tallest = cards.reduce((height, card) => {
            return Math.max(height, card.offsetHeight);
        }, 0);

        if (!tallest) {
            return;
        }

        cards.forEach((card) => {
            card.style.minHeight = `${tallest}px`;
        });

        if (slider._brandCardsSwiper && !slider._brandCardsSwiper.destroyed) {
            slider._brandCardsSwiper.update();
        }
    }

    function scheduleEqualizeCardHeights(slider) {
        window.requestAnimationFrame(() => {
            equalizeCardHeights(slider);
        });
    }

    function bindHeightRefreshTriggers(slider) {
        const images = slider.querySelectorAll('img');

        images.forEach((image) => {
            if (image.dataset.brandCardHeightBound) {
                return;
            }

            image.dataset.brandCardHeightBound = 'true';

            if (!image.complete) {
                image.addEventListener('load', () => scheduleEqualizeCardHeights(slider), { once: true });
            }
        });

        if (document.fonts && !slider.dataset.brandCardFontsBound) {
            slider.dataset.brandCardFontsBound = 'true';
            document.fonts.ready.then(() => scheduleEqualizeCardHeights(slider));
        }
    }

    function mountSlider(slider) {
        const wrapper = slider.querySelector('.swiper-wrapper');
        const paginationEl = slider.querySelector('.swiper-pagination');

        if (!wrapper || !paginationEl) {
            return;
        }

        const cards = collectCardsInOrder(wrapper);

        if (!cards.length) {
            return;
        }

        const previousSwiper = slider._brandCardsSwiper;
        let anchorCardIndex = 0;

        if (previousSwiper && !previousSwiper.destroyed) {
            anchorCardIndex = getAnchorCardIndex(wrapper, previousSwiper);
            previousSwiper.destroy(true, true);
        }

        slider._brandCardsSwiper = null;

        const ordered = cards.slice();
        wrapper.replaceChildren(...ordered);

        const mode = getLayoutMode();
        const groups = groupForMode(ordered, mode);
        buildSlidesFromGroups(wrapper, groups);

        slider.dataset.brandCardsLayoutMode = mode;

        const targetSlide = slideIndexContainingCard(groups, anchorCardIndex);
        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 500,
            watchOverflow: false,
            initialSlide: Math.min(targetSlide, Math.max(0, groups.length - 1)),
            pagination: {
                el: paginationEl,
                clickable: true,
            },
        });

        slider._brandCardsSwiper = swiper;

        bindHeightRefreshTriggers(slider);
        scheduleEqualizeCardHeights(slider);
    }

    function debounce(fn, ms) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(fn, ms);
        };
    }

    function subscribeMediaQuery(mediaQuery, handler) {
        if (typeof mediaQuery.addEventListener === 'function') {
            mediaQuery.addEventListener('change', handler);
        } else if (typeof mediaQuery.addListener === 'function') {
            mediaQuery.addListener(handler);
        }
    }

    sliders.forEach((slider) => {
        mountSlider(slider);

        const onResize = debounce(() => {
            const mode = getLayoutMode();
            if (mode !== slider.dataset.brandCardsLayoutMode) {
                mountSlider(slider);
            } else {
                scheduleEqualizeCardHeights(slider);
            }
        }, 150);

        const onBreakpointChange = () => {
            const mode = getLayoutMode();
            if (mode !== slider.dataset.brandCardsLayoutMode) {
                mountSlider(slider);
            }
        };

        window.addEventListener('resize', onResize);
        subscribeMediaQuery(window.matchMedia('(max-width: 991px)'), onBreakpointChange);
        subscribeMediaQuery(window.matchMedia('(max-width: 767px)'), onBreakpointChange);
    });
});
